module.exports = __webpack_public_path__ + "static/media/bill.9dd7f8ba.svg";